import { Button, CardActions, CardContent, CircularProgress, Link, TextField } from "@mui/material";
import React, { useEffect, useMemo } from "react";
import { useAlerts } from "../../../providers";
import { AuthenticationInstance } from "../../../utils/authenticationClass";
import { DialogHeader } from "../../generics/dialog-header";

export const VerifyAccountDialog = ({
  username,
  password, // NEEDED TO SIGNIN AFTER VERIFYING
  cancel,
  ok,
}: {
  username: string;
  password: string;
  cancel: () => void;
  ok: (result: any) => void;
}) => {
  const [state, setState] = React.useState({
    code: "",
  });
  const [loading, setLoading] = React.useState(false);
  const { showError, showSuccess } = useAlerts();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState((curr) => ({
      ...curr,
      [e.target.name]: e.target.value,
    }));
  };

  useEffect(() => {
    AuthenticationInstance.handleSendVerificationCode(username);
  }, []);

  const isValid = useMemo(() => {
    return state.code.length > 0;
  }, [state]);

  const handleVerify = async () => {
    setLoading(true);
    AuthenticationInstance.handleVerify(username, state.code)
      .then(({ isSignUpComplete = false }) => {
        if (!isSignUpComplete) {
          showError("Account not verified");
          return;
        }
        AuthenticationInstance.handleSignIn({ username, password }).then((res) => {
          showSuccess("Successfully verified and logged in");
          ok(res);
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <DialogHeader title="Verify Account" subheader={`Enter the verification code sent to your email`} />
      <CardContent>
        <TextField
          fullWidth
          label="Code"
          margin="normal"
          name="code"
          onChange={handleChange}
          value={state.code}
          autoComplete="verification-code"
          variant="outlined"
        />
        <Link href="/" variant="body2">
          Resend Code
        </Link>
      </CardContent>
      <CardActions sx={{ justifyContent: "space-between" }}>
        <Button variant="text" onClick={cancel} size="small" sx={{ color: "text.secondary" }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!isValid && !loading}
          onClick={handleVerify}
          startIcon={loading ? <CircularProgress sx={{ color: "inherit" }} size={20} /> : null}
        >
          Verify
        </Button>
      </CardActions>
    </>
  );
};
